import { MessageBar, MessageBarType, MessageBarButton, mergeStyleSets, FontSizes, getTheme } from '@fluentui/react';
import React from 'react';

const theme = getTheme();

const classNames = mergeStyleSets({
    root: {
        width: '100%',
        '& a': {
            textDecoration: 'none',
            color: '#0078d4',
        },
        '& a:hover': {
            textDecoration: 'underline',
        },
    },
    buttonStyles: {
        fontSize: FontSizes.mini,
        padding: `${theme.spacing.s2} ${theme.spacing.s1}`,
        minWidth: theme.spacing.s2,
        minHeight: theme.spacing.s2,
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    closeLink: {
        fontSize: '10px',
        color: '#666',
        textDecoration: 'none',
        cursor: 'pointer'
    }
})

const LicenseMessagePane = ({ paneType, message, onClose, onUpgrade }) => {
    const getBackgroundColor = () => {
        switch (paneType) {
            case MessageBarType.warning:
                return '#F7CB47';
            case MessageBarType.info:
                return '#f3f2f1';
            default:
                return '#f8f9fa';
        }
    };

    return (
        <div className={classNames.root}>
            <MessageBar
                messageBarType={paneType}
                isMultiline={true}
                styles={{
                    root: {
                        backgroundColor: getBackgroundColor(),
                    }
                }}
                actions={
                    <div className={classNames.actionsContainer}>
                        <MessageBarButton
                            onClick={onUpgrade}
                            className={classNames.buttonStyles}
                        >
                            Upgrade
                        </MessageBarButton>
                        <a 
                            href="#" 
                            onClick={(e) => { e.preventDefault(); onClose(); }}
                            className={classNames.closeLink}
                        >
                            Close
                        </a>
                    </div>
                }
            >
                {message}
            </MessageBar>
        </div>
    )
}

export default LicenseMessagePane;